/** @license See the LICENSE file. */
// This code is auto-generated, do not modify this file!
const version = '2.8.5';
export { version };
//# sourceMappingURL=version.js.map